import { recoverEmiThroughSip } from "../../engine/calculations";

const config = {
  key: "recover-emi-through-sip",
  title: "Recover Your EMIs through SIPs",
  category: "Wealth Strategies",
  description: "See how investing your EMI amount via SIP for the loan tenure could offset the interest you pay.",
  fields: [
    { key: "emi", label: "Monthly EMI", type: "currency", default: 25_000, min: 500, max: 10_00_000 },
    { key: "loanTenureYears", label: "Loan tenure (years)", type: "number", default: 15, min: 1, max: 30 },
    { key: "returnRate", label: "Expected annual return (SIP)", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
  ],
  chart: {
    type: "bar",
    xKey: "name",
    series: [{ key: "amount", label: "Amount", colorVar: "--gold" }],
  },
  compute(values) {
    const emi = Number(values.emi) || 0;
    const loanTenureMonths = Math.round((Number(values.loanTenureYears) || 0) * 12);
    const annualRate = (Number(values.returnRate) || 0) / 100;

    const result = recoverEmiThroughSip(emi, loanTenureMonths, annualRate);

    return {
      headline: { label: "SIP gains available to offset interest", value: result.gains },
      note: "Illustrative only — the SIP's own gains, not a calculation of your loan's actual interest (which depends on the loan's principal and rate).",
      extraHeadlines: [{ label: "SIP future value", value: result.futureValue }],
      breakdown: [{ label: "Total invested (EMI × months)", value: result.totalInvested }],
      series: [
        { name: "Invested", amount: result.totalInvested },
        { name: "Future Value", amount: result.futureValue },
      ],
    };
  },
};

export default config;
